const videoVisitWhen = ["today", "tomorrow", "dayAfterTomorrow"];
const videoVisitReason = ["general visit", "neck pain", "back pain"];
const videoVisitZip = { key: "zip" };

export const VideoVisitModel = {
  videoVisitWhen,
  videoVisitReason,
  videoVisitZip,
};
